import { ATTESTATIONS_INCOMPLETE_SEMESTERS, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import ShowIncompleteSemesters from "./List";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";

export const resources = {
  isMenu: true,
  icon: <SpellcheckIcon />,
  name: StudentServicePath + ATTESTATIONS_INCOMPLETE_SEMESTERS,
  title: "Прекъсващи за незаверен семестър",
  list: <ShowIncompleteSemesters />,
  permission: permissions.canInterruptForMissingAttestations,
};
